module.exports = __webpack_public_path__ + "img/mail-icon.63e6890a.svg";